<div class="app-for-creators">
    <section class="h-banner">
     <div class="container">
            <h1> <span>Next generation event streaming</span><br>for all your hybrid and virtual events</h1>
            <p>Where creators and their communities connect</p>
            <button mat-flat-button color="primary" class="flat-primary-button mr-3" routerLink="/request-for-demo">Request Demo</button>
            <button mat-flat-button color="accent" class="flat-secondary-button" routerLink="/pre-register">Pre Register</button>
            <!-- <div class="row justify-content-center">
                <div class="col-8">
                    <div class="H-Text1">Arevea is your <span>virtual stage</span> </div>
                    <div><a routerLink="browse" class="H-btn">Explore</a></div>
                    <a><img src="assets/website/homepage/arrow-down.svg"></a>
                </div>
            </div> -->
        </div>
    </section>
    <section class="h-sec2">
        <div class="container">
            <div class="row text-center hs2-icons">
                <div class="col-12 col-md-4">
                    <div class="hs2-text1">Create</div>
                    <div class="icon">
                        <!-- <img src="assets/website/homepage/hs2-icon1.svg"> -->
                        <app-svg [icon]="'hs2-icon1'"></app-svg>
                    </div>
                    <span class="hs2-text2">Effortless Cloud-based Production</span>
                </div>
                <div class="col-12 col-md-4">
                    <div class="hs2-text1">Connect</div>
                    <div class="icon">
                        <!-- <img src="assets/website/homepage/hs2-icon2.svg"> -->
                        <app-svg [icon]="'hs2-icon2'"></app-svg>
                    </div>
                    <span class="hs2-text2">Global Broadcasting at Scale</span>
                </div>
                <div class="col-12 col-md-4">
                    <div class="hs2-text1">Inspire</div>
                    <div class="icon">
                        <!-- <img src="assets/website/homepage/hs2-icon3.svg"> -->
                        <app-svg [icon]="'hs2-icon3'"></app-svg>
                    </div>
                    <span class="hs2-text2">Real-time Interactive Engagement</span>
                </div>
            </div>
        </div>
    </section>
    <section>
        <carousel [noPause]="true">
            <ng-container *ngFor="let a of catList">
                <slide>
                    <div class="carousel-sec banner-slider-image"
                        [ngStyle]="{'background-image': 'url(' + a.image + ')'}">
                        <div class="container">
                            <h2>{{a.text1}} </h2>
                        </div>
                    </div>
                </slide>
            </ng-container>
        </carousel>
    </section>
    <!-- <section class="bottom-text">
            <div>Host Your <span id="example"></span>
        </div>
    </section> -->
    <section class="bottom-text row no-gutters" [ngClass]="{'pt-55':hideHost}">
        <div class="col-lg-6 col-md-6 txt-right col-12" *ngIf="!hideHost">
            Host Your
        </div>
        <div class="{{!hideHost ? 'col-lg-6 col-md-6 txt-left pl-15 col-12' : 'text-center pl-15 col-12'}}"
            [ngClass]="{'pad-t-30':hideHost}">
            <span id="example"></span>
        </div>
    </section>
    <!-- <section class="carousel-sec" style="background-image: url(assets/website/homepage/live-music.jpg);">
        <div class="container">
            <h2>Live Music & Performances </h2>
        </div>
        <div class="bottom-text">
            Host Your <span>Concert</span>
        </div>
    </section> -->
    <section class="h-sec3">
        <div class="container">
            <h2 class="text-center"><span>How</span> It Works</h2>
            <div class="howitworks-list">
                <div class="each-box">
                    <div class="box">
                        <div class="count">1</div>
                        <img src="assets/website/homepage/hiw-icon1.svg">
                    </div>
                    <div class="name">Create</div>
                </div>
                <div class="each-box">
                    <div class="box">
                        <div class="count">2</div>
                        <img src="assets/website/homepage/hiw-icon2.svg">
                    </div>
                    <div class="name">Promote</div>
                </div>
                <div class="each-box">
                    <div class="box">
                        <div class="count">3</div>
                        <img src="assets/website/homepage/hiw-icon3.svg">
                    </div>
                    <div class="name">Produce</div>
                </div>
                <div class="each-box">
                    <div class="box">
                        <div class="count">4</div>
                        <img src="assets/website/homepage/hiw-icon4.svg">
                    </div>
                    <div class="name">Broadcast</div>
                </div>
                <div class="each-box">
                    <div class="box">
                        <div class="count">5</div>
                        <img src="assets/website/homepage/hiw-icon5.svg">
                    </div>
                    <div class="name">Engage</div>
                </div>
            </div>
        </div>
    </section>
    <section class="h-sec4">
        <div class="container">
            <h2 class="text-center">Your bespoke <span>branded studio</span> </h2>
            <div class="text-center">
                <div class="hs4-box rm">
                    <img src="assets/website/homepage/bs-icon1.svg">
                    Run your events like a near real-time interactive TV show
                </div>
            </div>
            <div class="text-center">
                <div class="hs4-box lm">
                    <img src="assets/website/homepage/bs-icon2.svg">
                    <span>Control your event production</span>
                </div>
            </div>
            <div class="text-center">
                <div class="hs4-box rm">
                    <img src="assets/website/homepage/bs-icon3.svg">
                    <span>Prepare creators in the Backstage</span>
                </div>
            </div>
            <div class="text-center">
                <div class="hs4-box lm">
                    <img src="assets/website/homepage/bs-icon4.svg">
                    Sequence, mix and switch real-time in the cloud
                </div>
            </div>
            <div class="text-center">
                <div class="hs4-box rm">
                    <img src="assets/website/homepage/bs-icon5.svg">
                    Live and pre-recorded content with upto 12 creators in a single live stream
                </div>
            </div>
        </div>
    </section>
    <section class="h-sec5">
        <div class="container">
            <h2 class="text-center"><span>Interactively engage </span> <br> with your audience </h2>
            <!-- <div class="row justify-content-center">
                <div class="col-12 col-md-7">
                    <div class="hs5-box text-center">
                        <img src="assets/website/homepage/mobile-img1.png">
                    </div>
                    <div class="name">Chats</div>
                </div>
            </div> -->
            <div class="row">
                <div class="col-12 col-md-3">
                    <div class="hs5-box2">
                        <h3>Overlays</h3>
                        <p>Cloud graphics that enhance the quality of your production</p>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="hs5-box2 color">
                        <h3>Chats</h3>
                        <p> Private and public chats to connect, build and grow communities</p>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="hs5-box2">
                        <h3>Polls</h3>
                        <p>Gather feedback from your audience and drive engagement</p>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="hs5-box2 color">
                        <h3>Reactions</h3>
                        <p>Receive your applause, love and likes through emojis</p>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="hs5-box2 color mob-bg-color">
                        <h3>Social Media Integration</h3>
                        <p>Publish and discuss your tweets real-time during the show</p>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="hs5-box2 active-bg-color">
                        <h3>Ads</h3>
                        <p>Increase brand exposure and impressions for your sponsors</p>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="hs5-box2 color mob-bg-color">
                        <h3>Q&A</h3>
                        <p>Respond to your audience questions in a dedicated channel or take questions live from your
                            fan or attendee</p>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="hs5-box2 ac active-bg-color">
                        <h3>Tips</h3>
                        <p>Receive tips from your fans while you perform</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="h-sec6 ">
        <h2 class="text-center">Build your next <br>
            <span>event in minutes</span>
        </h2>
        <div class="container">
            <div class="row no-gutters align-items-center hide-mobile">
                <div class="col-12 col-md-4">
                    <div class="build-steps">
                        <div class="step">
                            <img src="assets/website/homepage/build-icon1.svg">
                            Host small-scale or large-scale events
                        </div>
                        <div class="step">
                            <img src="assets/website/homepage/build-icon2.svg">
                            <span>Raise money for charities</span>
                        </div>
                        <div class="step">
                            <img src="assets/website/homepage/build-icon3.svg" width="30" height="24">
                            Sell tickets & manage registration
                        </div>
                        <div class="step">
                            <img src="assets/website/homepage/build-icon4.svg">
                            <span class="lh-36">Simulcast at ease</span>
                        </div>
                        <div class="step">
                            <img src="assets/website/homepage/build-icon5.svg" width="30" height="20">
                            <span>Access event analytics</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-8">
                    <div class="build-img" style="background-image: url('assets/website/homepage/build-img1.jpg');">

                    </div>
                </div>
            </div>
            <div class="row no-gutters align-items-center d-mobile">
                <div class="col-12 col-md-8">
                    <div class="build-img" style="background-image: url('assets/website/homepage/build-img1.jpg');">

                    </div>
                </div>
                <div class="col-12 col-md-4 mt-40">
                    <div class="build-steps">
                        <div class="step">
                            <img src="assets/website/homepage/build-icon1.svg">
                            Host small-scale or large-scale events
                        </div>
                        <div class="step">
                            <img src="assets/website/homepage/build-icon2.svg">
                            <span>Raise money for charities</span>
                        </div>
                        <div class="step">
                            <img src="assets/website/homepage/build-icon3.svg" width="30" height="24">
                            Sell tickets & manage registration
                        </div>
                        <div class="step">
                            <img src="assets/website/homepage/build-icon4.svg">
                            <span class="lh-36">Simulcast at ease</span>
                        </div>
                        <div class="step">
                            <img src="assets/website/homepage/build-icon5.svg" width="30" height="20">
                            <span>Access event analytics</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="booxdemo text-center">
        <!-- <h2 >Book a Demo</h2> -->
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md-6">
                    <img src="assets/website/homepage/demo-img.jpg" class="rounded img-fluid">
                </div>
                <div class="col-12 col-md-6 mar-t-25">
                    <button mat-flat-button color="primary" class="flat-primary-button"
                        routerLink="/request-for-demo">Book a
                        Demo</button>
                </div>
            </div>
        </div>

    </section>
    <section class="stayconnect text-center">
        <h2>Stay connected</h2>
        <div>
            <!-- <input placeholder="Email Us"> -->
            <button mat-flat-button color="primary" class="flat-primary-button" routerLink="/contactus">Contact
                Us</button>
        </div>
    </section>
</div>
